import type { GetResolutionOptionsTypeEnum } from '@backmarket/http-api/src/api-specs-resolution-engine/types/common'

import type { ResolutionOption } from '~/api/resolution-engine/types/GetResolutionOptions.types'

export const isResolutionOptionAvailable = (
  resolutionOptions: ResolutionOption[],
  resolutionoptionType: GetResolutionOptionsTypeEnum,
) => {
  return resolutionOptions.some((item) => item.type === resolutionoptionType)
}
